import { Dispatch } from "redux";
// import { BACKEND_API_URL } from "../config/config";
import QueryService from "../services/queryService";
import { GetAPIParams } from "../model/queryService.model";
import { appInsights } from "../pages/router";

export const FILTER_OPTIONS = "FILTER_OPTIONS";

const BACKEND_API_URL=process.env.REACT_APP_BACKEND_API_URL

export const getAllFilters = (selectedVendor: string) => {
	selectedVendor = selectedVendor?.replace("&", "%26");
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url =
				selectedVendor == null
					? `/getAllFilters`
					: `/getAllFilters?vendor=${selectedVendor}`;
			const data = await queryService.runQuery(url, "GET");
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					//redux removed
					// dispatch({ type: FILTER_OPTIONS, data: data })
				}
				return data;
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNIAdata = (payload: any) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async (payload: any) => {
			let url = `/getNIAdata`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData(payload)
			.then((res) => {
				if (res?.status === 200) {
					return res;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getRebateData = (payload: any) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getRebateData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPerformanceDataAPI = () => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getVendorData`;
			const data = await queryService.runQuery(url, "GET");
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Performance details based on L1, L2, L3, District or Supplier",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};
export const submitCrossSellRecommendation = () => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/submitCrossSellRecommendation`;

		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const getCrossSellCustomerList = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = payload.isUpSell
			? `/getCrossSellCustomerList`
			: `/getCrossSellCustomerList`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const getCrossSellItemListByCustomer = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCrossSellItemListByCustomer?customer=${payload.customer}&l1=${payload.l1}&l4=${payload.l4}&l3=${payload.l3}`;
		if (payload.divisionId.length > 0) {
			url += `&location=${payload.divisionId}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const getUpSellOpportunities = (payload: any, location: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getUpSellOpportunityByCustomer?customer=${payload.customer}`;
		if (location.length > 0) {
			url += `&location=${location}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const getCrossSellItemsByCustomerOrItem = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCrossSellItemsByCustomerOrItem`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
// export const getCrossSellFiltersData = () => {
//   const queryService = new QueryService(BACKEND_API_URL);
//   const fetchData = async () => {
//     let url = `/getCrossSellFiltersData`;
//     const data = await queryService.runQuery(url, "GET");
//     return data;
//   };

//   return fetchData()
//     .then((data) => {
//       return data;
//     })
//     .catch(() => {
//       console.log("Could Not fetch data");
//     });
// };

export const getCrossSellFiltersData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCrossSellFiltersData`;
		const data = await queryService.runQuery(url, "POST", payload);

		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getUpSellRecommendationData = (payload: any, location: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getUpSellRecommendationData?customer=${payload.customer}`;
		if (location.length > 0) {
			url += `&location=${location}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const getUpSellLevelFourRecommendationData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getLevelFourData?customer=${payload.customer}&l4=${payload.l4}&itemId=${payload.itemId}`;
		if (payload.divisionId.length > 0) {
			url += `&location=${payload.divisionId}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const putAPI = (url: string, payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};
	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log(
				`error in putAPI method of url - ${url} and Error is`,
				err
			);
		});
};
export const UpdateUpSellRecommendationIncudeBit = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/saveUpSellItemData`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateUpSellRecommendation API --", err);
		});
};
export const getTotalPageNumberForCrossSell = (payload: any, isUpSell: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCrossSellCustomerListTotalCount?isUpSell=${isUpSell}`;
		const data = await queryService.runQuery(
			url,
			"POST",
			payload,
			isUpSell
		);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const updateCrossSellUpsellDataRec = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/updateCrossSellUpSellDataRec`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateUpSell API --", err);
		});
};
export const getCrossSellL4DataByCustomer = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCrossSellL4DataByCustomer?customer=${payload.customer}&l1=${payload.l1}&l3=${payload.l3}`;
		if (payload.divisionId.length > 0) {
			url += `&location=${payload.divisionId}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const acceptCrossSellRecommendation = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/acceptCrossSellRecommendation`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

// export const getCrossSellCustomerFilter = () => {
//   const queryService = new QueryService(BACKEND_API_URL);
//   const fetchData = async () => {
//     let url = `/getCrossSellFilter`;
//     const data = await queryService.runQuery(url, "GET");
//     return data;
//   };
//   return fetchData()
//     .then((data) => {
//       return data;
//     })
//     .catch(() => {
//       console.log("Could Not fetch data");
//     });
// };

export const getCrossSellCustomerFilter = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCrossSellFilter`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const saveCrossSellItemVolume = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/saveCrossSellItemVolume`;

		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const rejectCrossSellRecommendation = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/rejectCrossSellRecommendation`;

		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPerformanceOverviewData = () => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getVendorData`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getAllFiltersCostOptimization = (payload: any) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async (payload: any) => {
			let url = `/getAllFiltersCostOptimization`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData(payload)
			.then((res) => {
				if (res?.status === 200) {
					appInsights.trackEvent({
						name: "Cost optimization filter data",
						properties: { value: res.data },
					});
					return res.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getOpportunitiesFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getAllFiltersBenchmarkOpp`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getAllFiltersPerformance = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getAllFiltersNIAPerformance`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getCostOptimizationChartsData = (payload: any) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async (payload: any) => {
			let url = `/getCostOptimizationChartsData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData(payload)
			.then((res) => {
				if (res?.status === 200) {
					return res;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNIAPerformanceGraphData = (payload: any) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async (payload: any) => {
			let url = `/getNIAPerformanceGraphData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData(payload)
			.then((res) => {
				if (res?.status === 200) {
					return res;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getOpportunitiesSuppliers = (payload: any = {}) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABenchmarkOppData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Peer benchmark opportunity details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getCostOptimizationData = (payload: any) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async (payload: any) => {
			let url = `/getCostOptimizationData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData(payload)
			.then((res) => {
				if (res?.status === 200) {
					appInsights.trackEvent({
						name: "cost optimization data",
						properties: { value: res.data },
					});
					return res.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const updateCostOptimizationData = (payload: any) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async (payload: any) => {
			let url = `/updateCostOptimizationData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData(payload)
			.then((res) => {
				if (res?.status === 200) {
					appInsights.trackEvent({
						name: "updated cost optimization meterial data",
						properties: { value: payload },
					});
					return res.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getSupplierPeerRebate = (payload: any = {}) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABenchmarkOppRebateData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Peer benchmark Rebate data details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNIAValueTrackerData = (payload: any = {}) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIAValueTrackerData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "value tracker data details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNIAValueTrackerGraphData = (payload: any = {}) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIAValueTrackerGraphData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "value tracker graph data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNIARebateUpdateData = (payload: any = {}) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIARebateUpdateData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "rebate update",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const updateNIARebateData = (payload: any = {}) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/updateNIARebateData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "rebate update",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const submitOpportunities = (payload: any) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/updateBenchmarkOppData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNIANextTierOppdata = (payload: any = {}) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIANextTierOppdata`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getCategorySummaryData = (payload: any) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getCatProfSummData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "category profitability data",
						properties: { value: data.data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getDashboardFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getAllFiltersCatProf`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "category profitability filter data",
						properties: { value: payload },
					});
					// dispatch({ type: FILTER_OPTIONS, data: data })
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNextTierFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getAllFiltersNextTierOpp`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getRecommendations = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getCatProfDetailsData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNIASimulatorData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getNIASimulatorData`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};
	return fetchData()
		.then((data) => {
			appInsights.trackEvent({
				name: "Simulator data details",
				properties: { value: data },
			});
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getAllNIASimulator = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getAllNIASimulator`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};
	return fetchData()
		.then((data) => {
			appInsights.trackEvent({
				name: "Nia simulator vendor and rebate categories details",
				properties: { value: data },
			});
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getSpendRebateTrendView = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getNIASimulatorRebateTrendViewData`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};
	return fetchData()
		.then((data) => {
			appInsights.trackEvent({
				name: "simulator chart data rebate data",
				properties: { value: data },
			});
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const updateNIASimulatorData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/updateNIASimulatorData`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};
	return fetchData()
		.then((data) => {
			appInsights.trackEvent({
				name: "updated simulator data",
				properties: { value: payload },
			});
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

// Supplier Consolidation
export const getAllSuppliers = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getSupplierConsolidationCategoryOverview`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "top and tail end suppliers details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const updateTailTopShift = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/updateSupplierConsolidationTopSupplier`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Tail to top or top to tail updation for suppliers",
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not update data");
			});
	};
};

export const getSpendShiftData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getSupplierConsolidationSpendShift`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Spend shift data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getUpdatedStatus = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getSupplierConsolidationIsUpdated`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "last updated details for corresponding L3",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};
export const getDistrictFilterForExport = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getDistrictFilterForExport`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "supplier consolidation district export filter data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getSupplierConsolidationFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getAllFiltersSupplierConsolidation`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "supplier consolidation filter data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getAllCategoryTrackingFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getCategoryTrackingFilters`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "csategory tracking filter data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getCategoryTrackingStepsData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getCategoryTrackingStepsData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "category tracking steps data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getCategoryTrackingInfoData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getCategoryTrackingInfoData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "category tracking info data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const updateCategoryTrackingData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/updateCategoryTrackingData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "update category tracking data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getSKURationalisationData = () => {
	// const queryService = new QueryService(GRAYBAR_BACKEND_API_URL);
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getSKUData`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const UpdateSKUData = (payload: any, acceptAll = false) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/updateSKUData`;
		if (acceptAll) {
			url += `?isAll=1`;
		}
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};
	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in updateSKUData update APi --", err);
		});
};

export const submitSKU = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/submitSKU`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in submitSKU update APi --", err);
		});
};

export const UpdateBrandCost = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/updateMarginBrainData`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateBrandCost update APi --", err);
		});
};

export const submitBCI = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/submitBCI`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in submitSKU update APi --", err);
		});
};

export const UpdateSaveReason = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/saveReasonBCI`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateBrandCost update APi --", err);
		});
};

export const getPricingCustomerList = (payload: any, body: any = {}) => {
	// const queryService = new QueryService(GRAYBAR_BACKEND_API_URL);
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getPricingCustomerList1?pageNumber=${payload.data.pageNumber}&pageSize=${payload.data.pageSize}&customer=${payload.data.customer}&order=${payload.data.order}&orderBy=${payload.data.orderBy}`;
		if (payload.data.home) {
			// console.log("payload", payload.home)
			url += `&home=${payload.data.home}`;
		}
		if (payload.data.minOpp !== "") {
			url += `&minOpp=${payload.data.minOpp}&maxOpp=${payload.data.maxOpp}`;
		}

		const data = await queryService.runQuery(url, "POST", body);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPricingCustomerListData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getPricingCustomerList`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};
	return fetchData()
		.then((data) => {
			appInsights.trackEvent({
				name: "pricing customer list data",
				properties: { value: data },
			});
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPricingDistrictLevelData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getPricingDistrictLevelData`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};
	return fetchData()
		.then((data) => {
			appInsights.trackEvent({
				name: "pricing customer list data",
				properties: { value: data },
			});
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPricingDivsionDataByCustomer = (payload: any) => {
	// const queryService = new QueryService(GRAYBAR_BACKEND_API_URL);
	const queryService = new QueryService(BACKEND_API_URL);

	const fetchData = async () => {
		let vendor = payload?.master_vendor_name;
		vendor = vendor.replace("&", "%26");

		let url = `/getPricingForItemTemp?sku=${payload.itemId}&district=${payload.district}&peerGroupName=${payload?.peerGroupName}&master_vendor_name=${vendor}`;
		// if (payload.useOutlier) {
		//   url += `&enableOutlierRemoval=1`
		// }
		// if (payload.home) {
		//   url += `&home=${payload.home}`
		// }
		// if (payload.customer_class) {
		//   url += `&customer_class=${payload.customer_class}`
		// }
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPricingMonthlyTrend = (
	custId: string,
	l4: string,
	divisionId: string
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = divisionId
			? `/getPricingMonthlyTrend?customerId=${custId}&l4=${l4}&divisionId=${divisionId}`
			: `/getPricingMonthlyTrend?customerId=${custId}&l4=${l4}`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could not fetch the Pricing monthly data !");
		});
};

export const savePricingExecutedPrice = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = "/savePricingExecutedPrice";
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};
	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("Error in saving execution price--", err);
		});
};

export const getTotalPageNumber = (payload: any = {}) => {
	// const queryService = new QueryService(GRAYBAR_BACKEND_API_URL);
	const queryService = new QueryService(BACKEND_API_URL);

	const fetchData = async () => {
		let url = `/getPricingTotalRecords`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const updatePricingDataRec = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/updatePricingDataRec`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateBrandCost update APi --", err);
		});
};

export const getAPI = (
	url: string,
	queryParamsinArrayOfObject: Array<GetAPIParams> = []
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		queryParamsinArrayOfObject.forEach(
			(param: GetAPIParams, index: number) => {
				if (index === 0) {
					url += "?";
				}
				url += `${param.key.replace(/&/g, "%26")}=${param.value.replace(
					/&/g,
					"%26"
				)}`;
				if (index < queryParamsinArrayOfObject.length - 1) {
					url += "&";
				}
			}
		);
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Error in getAPI method");
		});
};

export const getPricingCustomerClass = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `getPricingForItemClassFilters?itemId=${payload.itemId}&price_pc=${payload.price_pc}&division=${payload.division}`;
		if (payload.home) {
			url += `&home=${payload.home}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPricingForItemsListTemp = (payload: any, body: any = {}) => {
	// const queryService = new QueryService(GRAYBAR_BACKEND_API_URL);
	const queryService = new QueryService(BACKEND_API_URL);

	const fetchData = async () => {
		let url = `/getPricingForItemsListTemp?&division=${payload.division}&customer=${payload.customer}`;

		const data = await queryService.runQuery(url, "POST", body);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const updateExecutedPrice = (payload: any) => {
	// const queryService = new QueryService(GRAYBAR_BACKEND_API_URL);
	const queryService = new QueryService(BACKEND_API_URL);

	const fetchData = async () => {
		let url = `/updateExecutedPrice`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const rejectExecutedPrice = (payload: any) => {
	// const queryService = new QueryService(GRAYBAR_BACKEND_API_URL);
	const queryService = new QueryService(BACKEND_API_URL);

	const fetchData = async () => {
		let url = `/rejectExecutedPrice`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPricingFilters = (payload: any) => {
	// const queryService = new QueryService(GRAYBAR_BACKEND_API_URL);
	const queryService = new QueryService(BACKEND_API_URL);

	const fetchData = async () => {
		let url = `/getPricingFilters`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPricingFiltersnew = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPricingFilters`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Parametric filter data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getSKUSubstituionTableData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getSKUSubstituionTableData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "sku substitution table data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const updateSKUSubstitutionTableData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/updateSKUSubstitutionTableData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "updated sku substitution table data",
						properties: { value: payload },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getSKUFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getSkuManagementFilters`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getSKUTaxonomy = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getSKUManagementCategories`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "sku management category data based on selection",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

// Baseline

export const getBaselineCategorySummary = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewCategorySummary`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "L1, L2, L3 category details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getBaselineSupplierSummary = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewSupplierSummary`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Supplier summary details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getBaselineL4ForTopSuppliers = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewL4Chart`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getBaselineDistrictSummaryByL4 = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewDistrictSummaryByL4`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "District summary L4 details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getBaselineMapView = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewDistrictSummaryMap`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "District summary map details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getBaselineParetoChart = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewParetoChart`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Supplier and sku summary pareto details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getParametricSuppliersData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIAParmetricViewSupplierSummary`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Parametric supplier summery details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getParametricMaterialData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIAParametricViewMaterialSummary`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Parametric supplier material level data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getParametricAttributeSelection = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIAParametricViewAttributeSelection`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Parametric selecetd attribute data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getParametricFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIAPrametricViewFilter`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Parametric filter data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getParametricAttributeData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIAParametricViewAttributeSummary`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Parametric attribute data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getBaselineSPaUtilization = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewSpaUtillSummary`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Spa utilization by sku details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getBaselineKPIs = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewKPIFilter`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "KPI details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getL4MaterialSummary = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewL4MaterialSummary`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "L4 material summary details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getSkuParetoExport = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getLossLeaderParetoExport`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Export Sku pareto details",
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getBaselineVendorSpa = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewVendorSpaSummary`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Supplier spa summary details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getBaselineFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIABaseViewFiltersData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					// dispatch({ type: FILTER_OPTIONS, data: data })
					appInsights.trackEvent({
						name: "Baseline filter details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

/* portfolio gap */

export const getPortfolioFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getAllFiltersPortfolioGap`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPortfolioDistrictData = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPortfolioGapDistrictLevelData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					// dispatch({ type: FILTER_OPTIONS, data: data })
					appInsights.trackEvent({
						name: "Portfolio district data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPortfolioProductData = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPortfolioGapProductIdLevelData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					// dispatch({ type: FILTER_OPTIONS, data: data })
					appInsights.trackEvent({
						name: "Portfolio product level data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPortfolioGapSKULevelData = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPortfolioGapSKULevelData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					// dispatch({ type: FILTER_OPTIONS, data: data })
					appInsights.trackEvent({
						name: "Portfolio Gap SKU Level data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPreferredSupplierFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPreferredVendorFilters`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "supplier consolidation filter data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPreferredVendorDistrictData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPreferredVendorDistrictData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "top and tail end suppliers details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPreferredVendorDetailsData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPreferredVendorDetailsData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "top and tail end suppliers details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPreferredVendorChartData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPreferredVendorChartData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "top and tail end suppliers details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPreferredVendorDetailsChart = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPreferredVendorDetailsChart`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "strategic and tail supplier chart data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const updatePreferredSupplier = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/updatePreferredSupplier`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "updating the strategic and tail suppliers",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPreferredVendorByL4 = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPreferredVendorByL4`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "top and tail end suppliers details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPreferredSupplierExport = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPreferredSupplierExport`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "preferred supplier export",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getValueCaptureFilters = (payload: any = {}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getAllFiltersValueCapture`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "value capture filter data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getCategoryPerformanceGraphData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getCategoryPerformanceGraphData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category performance graph data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getValueCaptureGraphData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getValueCaptureGraphData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Value capture graph data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};
export const getValueCaptureMarginImprovementOverview = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getValueCaptureMarginImprovementOverview`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category performance graph data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getValueCaptureGraphDataSet2 = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getValueCaptureMarginGraph`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Value capture graph data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getValueCaptureMarginGraphData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getValueCaptureMarginGraphData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Value capture graph data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getValueCaptureExportData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getValueCaptureExportGraphData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Value capture graph data Export",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPricingExportData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPricingExportData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Pricing data Export",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getPortfolioGapExportData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getPortfolioGapExportData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Portfolio Gap data Export",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const updatePortfolioGap = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/updatePortfolioGap`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Portfolio Gap data Export",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getCategoryPerformanceAlerts = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getCategoryPerformanceAlerts`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category Performance Alert Data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getCategoryPerformanceAlertsFilters = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCategoryPerformanceAlertsFilters`;
		const data = await queryService.runQuery(url, "POST", payload);

		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getCategoryPerformanceAlertsOpportunity = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getCategoryPerformanceAlertsOpportunity`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category Performance Alert Data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getCategoryTrackingOverallData = (payload: {
	manager: any;
	l1: any;
	l2: any;
	l3: any;
}) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getCategoryTrackingOverallData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "category tracking overall data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getIntoStockExportData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getIntoStockExportData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category Performance Alert Data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getSpaExportData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getSpaExportData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category Performance Alert Data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getTailExportData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getTailExportData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category Performance Alert Data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNIANegotiationsData = (payload: any = {}) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIANegotiationsData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "nia negotiation overall rebate data details",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getNIANegotiationsGraphData = (payload: any = {}) => {
	return async (dispatch: Dispatch) => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getNIANegotiationsGraphData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "nia negotiation overall rebate graph data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getAllFiltersMDM = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getAllFiltersMDM`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category Performance Alert Data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getMDMGraphData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getMDMGraphData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category Performance Alert Data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

export const getMDMKPIData = (payload: any) => {
	return async () => {
		const queryService = new QueryService(BACKEND_API_URL);
		const fetchData = async () => {
			let url = `/getMDMKPIData`;
			const data = await queryService.runQuery(url, "POST", payload);
			return data;
		};
		return fetchData()
			.then((data) => {
				if (data?.status === 200) {
					appInsights.trackEvent({
						name: "Category Performance Alert Data",
						properties: { value: data },
					});
					return data.data;
				}
			})
			.catch(() => {
				console.log("Could Not fetch data");
			});
	};
};

